import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
let store = new Vuex.Store({
    state:{
        bigScreenSearchForm:{
            startTime : null,
            endTime : null
        },
    },

    // // 2. getters
    getters:{
        getBigScreenSearchForm(state){
            return state.bigScreenSearchForm;
        }
    },
    // 3. actions
    actions:{
        setBigScreenSearchForm({commit,state}, bigScreenSearchForm){
            commit("setBigScreenSearchForm", bigScreenSearchForm);
        }
    },
    // 4. mutations
    mutations:{
        setBigScreenSearchForm(state, bigScreenSearchForm){
            state.bigScreenSearchForm = bigScreenSearchForm;
        }
    }
});

export default store;


// WEBPACK FOOTER //
// ./src/store/store.js